/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PostCorporationsCorporationIdAssetsLocationsPosition } from './PostCorporationsCorporationIdAssetsLocationsPosition';
import {
    PostCorporationsCorporationIdAssetsLocationsPositionFromJSON,
    PostCorporationsCorporationIdAssetsLocationsPositionFromJSONTyped,
    PostCorporationsCorporationIdAssetsLocationsPositionToJSON,
    PostCorporationsCorporationIdAssetsLocationsPositionToJSONTyped,
} from './PostCorporationsCorporationIdAssetsLocationsPosition';

/**
 * 200 ok object
 * @export
 * @interface PostCorporationsCorporationIdAssetsLocations200Ok
 */
export interface PostCorporationsCorporationIdAssetsLocations200Ok {
    /**
     * item_id integer
     * @type {number}
     * @memberof PostCorporationsCorporationIdAssetsLocations200Ok
     */
    itemId: number;
    /**
     * 
     * @type {PostCorporationsCorporationIdAssetsLocationsPosition}
     * @memberof PostCorporationsCorporationIdAssetsLocations200Ok
     */
    position: PostCorporationsCorporationIdAssetsLocationsPosition;
}

/**
 * Check if a given object implements the PostCorporationsCorporationIdAssetsLocations200Ok interface.
 */
export function instanceOfPostCorporationsCorporationIdAssetsLocations200Ok(value: object): value is PostCorporationsCorporationIdAssetsLocations200Ok {
    if (!('itemId' in value) || value['itemId'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function PostCorporationsCorporationIdAssetsLocations200OkFromJSON(json: any): PostCorporationsCorporationIdAssetsLocations200Ok {
    return PostCorporationsCorporationIdAssetsLocations200OkFromJSONTyped(json, false);
}

export function PostCorporationsCorporationIdAssetsLocations200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCorporationsCorporationIdAssetsLocations200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'itemId': json['item_id'],
        'position': PostCorporationsCorporationIdAssetsLocationsPositionFromJSON(json['position']),
    };
}

export function PostCorporationsCorporationIdAssetsLocations200OkToJSON(json: any): PostCorporationsCorporationIdAssetsLocations200Ok {
    return PostCorporationsCorporationIdAssetsLocations200OkToJSONTyped(json, false);
}

export function PostCorporationsCorporationIdAssetsLocations200OkToJSONTyped(value?: PostCorporationsCorporationIdAssetsLocations200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'item_id': value['itemId'],
        'position': PostCorporationsCorporationIdAssetsLocationsPositionToJSON(value['position']),
    };
}

